const LUXURY_BRANDS = new Set(
  'bmw,mercedes,mercedes-benz,audi,porsche,tesla,lexus,maserati,ferrari,lamborghini,bentley,rolls-royce,jaguar,land rover,cadillac,infiniti,genesis,aston martin,bugatti,mclaren,range rover'.split(
    ','
  )
);
const PREMIUM_BRANDS = new Set(
  'volkswagen,vw,volvo,alfa romeo,skoda,mini,seat,jeep,toyota,honda,hyundai,kia,mazda,subaru,saab,acura,lincoln'.split(
    ','
  )
);
const ECONOMY_BRANDS = new Set(['dacia', 'lada', 'smart', 'daewoo', 'tata', 'chery', 'geely']);

const CITY_DEMAND = [
  { keys: ['paris'], mult: 1.4 },
  { keys: ['nice', 'cannes', 'monaco', 'antibes', 'saint-tropez'], mult: 1.32 },
  { keys: ['lyon', 'marseille'], mult: 1.22 },
  {
    keys: [
      'bordeaux',
      'toulouse',
      'nantes',
      'lille',
      'strasbourg',
      'rennes',
      'montpellier',
      'grenoble',
      'toulon',
      'aix',
    ],
    mult: 1.13,
  },
  { keys: ['genève', 'geneva', 'zürich', 'zurich', 'lausanne'], mult: 1.35 },
];

const AGE_MULT = [
  { from: 2023, mult: 1.22 },
  { from: 2020, mult: 1.08 },
  { from: 2016, mult: 0.88 },
  { from: 0, mult: 0.72 },
];

const KM_MULT = [1.18, 1.06, 0.96, 0.85, 0.74, 0.62];

export function estimateRevenue({ marque, locationName, annee, km }) {
  const brand = (marque || '').toLowerCase();
  const baseDaily = LUXURY_BRANDS.has(brand)
    ? 92
    : PREMIUM_BRANDS.has(brand)
      ? 66
      : ECONOMY_BRANDS.has(brand)
        ? 36
        : 50;

  const city = (locationName || '').toLowerCase();
  let locMult = 1.0;
  for (const { keys, mult } of CITY_DEMAND) {
    if (keys.some((k) => city.includes(k))) {
      locMult = mult;
      break;
    }
  }
  if (locMult === 1.0 && city.length > 0) locMult = 1.04;

  const year = parseInt(annee) || 2020;
  const ageMult = AGE_MULT.find((r) => year >= r.from)?.mult ?? 0.72;
  const kmMult = KM_MULT[parseInt(km)] ?? 0.96;

  const daily = Math.round(baseDaily * locMult * ageMult * kmMult);
  return {
    daily,
    min: Math.round(daily * 14),
    max: Math.round(daily * 22),
    mid: Math.round(daily * 18),
    segment: LUXURY_BRANDS.has(brand)
      ? 'Premium'
      : PREMIUM_BRANDS.has(brand)
        ? 'Confort'
        : ECONOMY_BRANDS.has(brand)
          ? 'Économique'
          : 'Standard',
  };
}
